import moment from "moment";
import React from "react";

export function normalizeType(t) {
  if (!t) return "";
  return String(t).toLowerCase();
}

export function getOperatorsForType(type) {
  const t = normalizeType(type);
  if (t === "boolean" || t === "bool") return [{ label: "=", value: "eq" }, { label: "!=", value: "ne" }];
  if (["number","integer","float","double","currency"].includes(t)) return [
    { label: "=", value: "eq" }, { label: "!=", value: "ne" },
    { label: ">", value: "gt" }, { label: "<", value: "lt" },
    { label: ">=", value: "gte" }, { label: "<=", value: "lte" }
  ];
  if (["date","datetime","timestamp"].includes(t)) return [
    { label: "=", value: "eq" }, { label: "!=", value: "ne" },
    { label: ">", value: "gt" }, { label: "<", value: "lt" }
  ];
  if (["picklist","select","enum"].includes(t)) return [{ label: "=", value: "eq" }, { label: "!=", value: "ne" }];
  return [{ label: "=", value: "eq" }, { label: "!=", value: "ne" }, { label: "contains", value: "contains" }];
}

export function extractPicklistValues(field) {
  if (!field || !field.raw) return null;
  const r = field.raw;
  return r.picklistValues || r.picklist_values || r.values || r.options || (r.meta && (r.meta.picklistValues || r.meta.values)) || null;
}

export function renderValue(value, fieldMeta) {
  if (value === null || value === undefined) return "";
  const type = fieldMeta?.type;

  if (type === "lookup" || type === "reference") {
    const displayName = value?.Name || value?.label || value?.name || "Unknown";
    const id = value?.id || value?._id;
    const parent_object_name = fieldMeta?.parent_object_name || "";
    if (!id) return displayName;
    return <a href={`/record/${parent_object_name}/${id}`} target="_blank" rel="noopener noreferrer">{displayName}</a>;
  }

  if (type === "date") return value ? new Date(value).toLocaleDateString() : "";
  if (type === "datetime") return value ? new Date(value).toLocaleString() : "";
  if (type === "boolean") return value ? "✔️" : "❌";
  if (type === "number" || type === "currency") return value.toLocaleString();
  if (typeof value === "object") return <pre style={{ background:"#f5f5f5", padding:10, borderRadius:6, maxWidth:600, overflowX:"auto" }}>{JSON.stringify(value,null,2)}</pre>;
  return value.toString();
}
export function extractGroupAliases(pipeline) {
  const aliases = [];

  for (const st of pipeline) {
    if (st.type === "$group" && Array.isArray(st.config?.aggregates)) {
      for (const agg of st.config.aggregates) {
        if (agg.as) aliases.push(agg.as);
      }
    }
  }

  return aliases;
}
